import { Stack, Icon } from '@fashionnovateam/nova-ui-toolkit';

function EmptyStateLayout() {
  return (
    <div className="flex justify-center items-center min-h-[225px] bg-gray-50">
      <div className="bg-white rounded-lg max-w-md">
        <Stack direction="col" gap="sm" className="text-center">
          <div className="flex justify-center">
            <Icon
              name="envelope/envelope-arrow-up"
              size="30px"
              variant="stroke"
              className="text-primary-700"
            />
          </div>

          {/* Main heading */}
          <p className="text-xl font-medium text-black">
            We&apos;ll email you if we like this style.
          </p>

          {/* Description text */}
          <p className="text-xsm text-base-disabled ">
            If we like the style, we&apos;ll email you with a request for more
            information. Once you fill out these details we may follow up with a
            purchase order!
          </p>
        </Stack>
      </div>
    </div>
  );
}

export default EmptyStateLayout;
